const withBypassComponent = (Component, enabled = true) => {
  if (enabled) {
    return Component;
  }
  return ({ children }) => children;
};

export { withBypassComponent };
